;(function () {
  angular
    .module('contrast.libraries')
    .controller('ModalLibraryApplicationsInstanceCtrl', [
      '$scope',
      '$uibModalInstance',
      'fileName',
      'apps',
      ModalLibraryApplicationsInstanceCtrl
    ])

  function ModalLibraryApplicationsInstanceCtrl(
    $scope,
    $uibModalInstance,
    fileName,
    apps
  ) {
    angular.extend($scope, {
      libName: fileName,
      apps: apps,

      cancel: cancel
    })

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
